"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

exports.styles = function (_a) {
  var colorStateHover = _a.colorStateHover,
      x1 = _a.x1,
      x4 = _a.x4,
      colorBgHighlight = _a.colorBgHighlight;
  return {
    container: {
      display: 'flex',
      alignItems: 'center',
      padding: x1 + "px " + x4 + "px",
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: colorStateHover.normal
      },
      overflow: 'hidden'
    },
    information: {
      display: 'flex',
      'flex-direction': 'column'
    },
    highlightClassName: {
      backgroundColor: colorBgHighlight.normal
    }
  };
};